import { StyleColorSchemeType } from '@/ui-kit/styles/enums';

const RangeCommonProps = {
  props: {
    className: {
      default: '',
      type: String,
    },
    value: {
      required: true,
      type: Object,
    },
    colorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    labelColorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    iconColor: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
  },
};

export default RangeCommonProps;
